import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxAlert } from "../../Limestone/AxAlert/AxAlert";
import { ProgressBarMode, ProgressBar } from "../Global/Progressbar";
import { RequestHelper } from "../../Lib/Helper/RequestHelper";
import { TicketList } from "../../Components/ProductList/TicketList";
import { Translations, I18nHelper } from "../../Lib/Helper/I18nHelper";
import Swal from "sweetalert2";

@ModuleName("Payment")
export class Payment implements AxInit {
    constructor(
        protected _Progressbar = new ProgressBar(),
        private _I18nHelper = new I18nHelper()
    ) { }

    AxInit(init: PaymentInit): void {
        this.checkSelectedDate(init.postData, init.ticketDefIsKGT23);
        $('.input-consent-doc-submit-button').on('click', () => {
            this.checkSelectedDate(init.postData, init.ticketDefIsKGT23);
        });

        if (init.processIndicatorActive) {
            let progress: number = init.progressBarMode == ProgressBarMode.Suballotment ? 4 : 3;

            this._Progressbar.Init({
                Mode: init.progressBarMode,
                Progress: progress
            });
        }

        $(document).on('click', '.btn__waiver_agree', (e) => {
            e.preventDefault();
            let waiverId = $(e.currentTarget).attr('waiver_id');
            this.checkReleaseOfLiability(waiverId);
        });
    }

    checkSelectedDate(postData, ticketDefIsKGT23) {
        const currentDate = new Date();
        const momentInstance = moment(currentDate);
        postData.forEach((value, index) => {
            const cartEntryDate = value?.Ticket?.ValidTo?.split('T')[0];
            if (cartEntryDate && cartEntryDate < momentInstance.format('YYYY-MM-DD') && !ticketDefIsKGT23) {
                $('#kt_portlet__overview').hide();
                $('#kt_portlet__resort_charge').hide();
                $('#kt_portlet__payment').hide();
                Swal.fire({
                    title: this._I18nHelper.GetTranslation(Translations.WrongDay),
                    text: this._I18nHelper.GetTranslation(Translations.WrongSelectedDay),
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: this._I18nHelper.GetTranslation(Translations.AdminClose)
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.href = '/';
                    }
                });
            }
        });
    }

    checkReleaseOfLiability(waiverModalNr) {
        let name = $('input[name=waiver-acceptance-name_' + waiverModalNr + ']').val();
        if (name != '') {
            AxessViewer.loadPartialView("/AxessWaiver/CheckLiability", {
                cartEntryID: $('#rel_liab_entryID').val(),
                name: name
            }, (result) => {
                if (result.success) {
                    $('input[name=relOfLiab_' + $('#rel_liab_entryID').val() + ']').prop('checked', true);
                    this.hideAllModals();
                } else {
                    Swal.fire({
                        title: this._I18nHelper.GetTranslation(Translations.Error),
                        html: this._I18nHelper.GetTranslation(Translations.WaiverSaveFail),
                        icon: 'error',
                        customClass: {
                            closeButton: 'btn btn-secondary',
                            confirmButton: 'btn btn-primary',
                        },
                        confirmButtonText: this._I18nHelper.GetTranslation(Translations.Ok),
                    });
                }
            }, {
                lockButtonSelector: '.btn__waiver_agree'
            });

        } else {
            $('input[name=waiver-acceptance-name]').addClass('invalid');
        }
    }

    hideAllModals() {
        $('#kt_modal_sm').modal('hide');
        $('#kt_modal_md').modal('hide');
        $('#kt_modal_lg').modal('hide');
        $('#kt_modal_xl').modal('hide');
        $('.modal-body').html('');
    }
}
class PaymentInit {
    processIndicatorActive: boolean;
    ticketDefIsKGT23: boolean;
    progressBarMode: ProgressBarMode;
    postData: any;
}